module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-2.025a7d22.jpg";